const initialState = {
  healthInsurance: [],
  covidVaccine: [],
  deliveryType: [],
  familyPlanningUsage: [],
  bloodGroup: [],
  motherFeeding: [],
  govCompensation: [],
  incomeAbility: [],
  disableCategory: [],
  ncdCount: [],
  deathReason: [],
  disableCount: [],
  getState: 0,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_HEALTH_INSURANCE_FULFILLED':
      return {
        ...state,
        getState: 2,
        healthInsurance: action.payload.data,
      }
    case 'GET_HEALTH_INSURANCE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_HEALTH_INSURANCE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_COVID_VACCINE_FULFILLED':
      return {
        ...state,
        getState: 2,
        covidVaccine: action.payload.data,
      }
    case 'GET_COVID_VACCINE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_COVID_VACCINE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_DELIVERY_TYPE_FULFILLED':
      return {
        ...state,
        getState: 2,
        deliveryType: action.payload.data,
      }
    case 'GET_DELIVERY_TYPE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_DELIVERY_TYPE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_FAMILY_PLANNING_USAGE_FULFILLED':
      return {
        ...state,
        getState: 2,
        familyPlanningUsage: action.payload.data,
      }
    case 'GET_FAMILY_PLANNING_USAGE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_FAMILY_PLANNING_USAGE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_BLOOD_GROUP_FULFILLED':
      return {
        ...state,
        getState: 2,
        bloodGroup: action.payload.data,
      }
    case 'GET_BLOOD_GROUP__REJECTED':
      return { ...state, getState: 3 }
    case 'GET_BLOOD_GROUP__PENDING':
      return { ...state, getState: 1 }

    case 'GET_MOTHER_FEEDING_FULFILLED':
      return {
        ...state,
        getState: 2,
        motherFeeding: action.payload.data,
      }
    case 'GET_MOTHER_FEEDING_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_MOTHER_FEEDING_PENDING':
      return { ...state, getState: 1 }

    case 'GET_GOVERNMENT_COMPENSATION_FULFILLED':
      return {
        ...state,
        getState: 2,
        govCompensation: action.payload.data,
      }
    case 'GET_GOVERNMENT_COMPENSATION_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_GOVERNMENT_COMPENSATION_PENDING':
      return { ...state, getState: 1 }

    case 'GET_INCOME_ABILITY_FULFILLED':
      return {
        ...state,
        getState: 2,
        incomeAbility: action.payload.data,
      }
    case 'GET_INCOME_ABILITY_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_INCOME_ABILITY_PENDING':
      return { ...state, getState: 1 }

    case 'GET_DISABLE_CATEGORY_FULFILLED':
      return {
        ...state,
        getState: 2,
        disableCategory: action.payload.data,
      }
    case 'GET_DISABLE_CATEGORY_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_DISABLE_CATEGORY_PENDING':
      return { ...state, getState: 1 }

    case 'GET_NCD_COUNT_FULFILLED':
      return {
        ...state,
        getState: 2,
        ncdCount: action.payload.data,
      }
    case 'GET_NCD_COUNT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_NCD_COUNT_PENDING':
      return { ...state, getState: 1 }

    case 'GET_DEATH_REASON_FULFILLED':
      return {
        ...state,
        getState: 2,
        deathReason: action.payload.data,
      }
    case 'GET_DEATH_REASON_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_DEATH_REASON_PENDING':
      return { ...state, getState: 1 }

    case 'GET_DISABILITY_COUNT_FULFILLED':
      return {
        ...state,
        getState: 2,
        disableCount: action.payload.data,
      }
    case 'GET_DISABILITY_COUNT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_DISABILITY_COUNT_PENDING':
      return { ...state, getState: 1 }

    default:
      return state
  }
}

export default reducer
